// Selección de montajes en el calendario para preparar una ruta (persistente en sessionStorage).
const KEY_SEL = "dnf-cal-seleccion";
const KEY_CTX = "dnf-cal-ctx";
export const KEY_REPARTO_SEL = "dnf-reparto-seleccion";

/** Motivo por el que una tarjeta NO es seleccionable (null = elegible). Misma semántica que la elegibilidad de Reparto. */
export const motivoNoElegible = (m) => {
  if (m.realizado) return "Ya realizado";
  if (m.en_ruta) return `Ya en ruta ${m.en_ruta.codigo}${m.en_ruta.fecha ? ` · ${m.en_ruta.fecha.slice(0, 10)}` : ""}`;
  if (!m.reprogramable) return m.bloqueo_motivo || "No elegible";
  if (m.espacio?.lat == null || m.espacio?.lon == null) return "Espacio sin geolocalizar (no se puede rutar)";
  return null;
};

export const snapshotMontaje = (m) => ({
  id: m.id, espacio_id: m.espacio?.id || null, espacio_nombre: m.espacio?.nombre || m.cliente_nombre || "—",
  ciudad: m.espacio?.ciudad || "", provincia: m.espacio?.provincia || "", peticion_codigo: m.peticion?.codigo || "",
  fecha_visible: m.fecha_visible ? m.fecha_visible.slice(0, 10) : null, fecha_programada: m.fecha_programada ? m.fecha_programada.slice(0, 10) : null,
  fecha_cita: m.fecha_cita || null, sugerido: !!m.sugerido,
});

export const destinoKey = (s) => s.espacio_id || `${s.espacio_nombre}|${s.ciudad}`;

export const leerSeleccion = () => { try { return JSON.parse(sessionStorage.getItem(KEY_SEL) || "[]"); } catch { return []; } };
export const guardarSeleccion = (arr) => sessionStorage.setItem(KEY_SEL, JSON.stringify(arr));
export const leerCtx = () => { try { return JSON.parse(sessionStorage.getItem(KEY_CTX) || "null"); } catch { return null; } };
export const guardarCtx = (ctx) => sessionStorage.setItem(KEY_CTX, JSON.stringify(ctx));
export const borrarCtx = () => sessionStorage.removeItem(KEY_CTX);
